import React from "react";
import AllSubjectTopics from "../../../Topics/AllSubjectTopics";


function FormulaMathTopics() {
  return (
    <>

      <AllSubjectTopics subject="math" type="formula" />

    </>
  );
}

export default FormulaMathTopics;